import { useCallback } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useHotelsAvailability } from "@tenant/hotels";

export const useFilterList = () => {
  const { t } = useI18nContext();
  const { handlers, context } = useHotelsAvailability();
  const handleFilterPriceUpdate = useCallback(
    ({ minPrice, maxPrice }) => {
      handlers.setPriceFilter({
        min: minPrice,
        max: maxPrice,
      });
    },
    [handlers]
  );

  const resetAllFilters = useCallback(() => {
    handlers.resetFilters();
  }, [handlers]);

  return {
    handlers: {
      onPriceChange: handleFilterPriceUpdate,
      onRatingChange: handlers.setStarRatingFilter,
      onCancellationChange: handlers.setCancellationFilter,
      onAmenitiesChange: handlers.setAmenitiesFilter,
      onPayLaterChange: handlers.setPayLaterFilter,
      onResetFilters: resetAllFilters,
      onResetRatingFilter: handlers.resetStarRatingFilter,
      onResetCancellationFilter: handlers.resetCancellationFilter,
      onResetAmenitiesFilter: handlers.resetAmenitiesFilter,
    },
    context,
    text: {
      price: {
        title: t("core-hotels.availabilityPage.filters.price.title"),
        description: t(
          "core-hotels.availabilityPage.filters.price.description"
        ),
      },
      starRating: {
        title: t("core-hotels.availabilityPage.filters.starRating.title"),
      },
      freeCancellation: {
        title: t("core-hotels.availabilityPage.filters.cancellation.title"),
      },
      amenities: {
        title: t("core-hotels.availabilityPage.filters.amenities.title"),
      },
      payLater: {
        title: t("core-hotels.availabilityPage.filters.payLater.title"),
        description: t(
          "core-hotels.availabilityPage.filters.payLater.description"
        ),
      },
      resetFilters: t("core-hotels.availabilityPage.filters.resetFilters"),
    },
  };
};
